import { createStyles } from 'antd-style'

export const useStyles = createStyles(() => ({
  content: {
    maxHeight: 480,
    overflow: 'hidden auto'
  }
}))
